import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {constants} from '@neosvoc/nv-platform-core-common';
import messages from '../../../../res/translations/messages';
import {Form, Formik} from 'formik';
import FormGroupField from '../../admin/FormGroupField';

class WhatsappConfigurator extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    handleSubmit(values) {
        values = Object.assign({}, this.props.values, values);
        if (values && values.code) {
            values.code = values.code.toUpperCase();
        }
        this.props.setFieldValue(`channels.${constants.CHANNEL_TYPES.WHATSAPP}`, values);
        this.toggleModal();
    }

    render() {
        const {values} = this.props;
        const enabled = !!(values && values.enabled);
        return (
            <button type="button" className="btn btn-sm btn-outline-secondary" disabled={!enabled} onClick={this.toggleModal}>
                <FormattedMessage {...messages.buttons.configureChannel} />
                <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.channels.whatsapp} />
                    </ModalHeader>
                    <Formik onSubmit={this.handleSubmit} initialValues={{code: values && values.code || ''}}>
                        {({handleSubmit}) => (
                            <Form onSubmit={handleSubmit}>
                                <ModalBody>
                                    <FormGroupField type="text" id="whatsapp-code" name="code" label={messages.surveys.modals.whatsappCode}
                                        prepend={constants.CHATBOT_PREFIX_CODE} />
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                                        <FormattedMessage {...messages.buttons.cancel} />
                                    </button>
                                    <button className="btn btn-primary" type="submit">
                                        <FormattedMessage {...messages.buttons.ok} />
                                    </button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                </Modal>
            </button>
        );
    }
}

export default WhatsappConfigurator;
